// input: "hello world", output: "Hello world"
const capitalizeFirstLetter = (word) => {
  if (word?.length)
    return word[0].toUpperCase() + word.substring(1).toLowerCase()
  return ''
}

// input: "hello world", output: "HELLO_WORLD"
const capitalizeAndJoinWithUnderscore = (word) => {
  const separated = word.split(" ")
  let finalString = "";
  for (let i in separated) {
    if (separated[i] === separated[separated.length - 1]) {
      finalString += separated[i].toUpperCase()
    } else {
      finalString += `${separated[i].toUpperCase()}_`
    }
  }
  return finalString
}

// input= "CATEGORY_VALUE", output = "Category Value"
const capitalizeAndRemoveUnderscore = (word) => {
  if (word) {
    const words = word.split("_")
    let output = ""
    for (let i in words) {
      output += `${capitalizeFirstLetter(words[i])} `
    }
    return output
  }
  return word ?? ""
}

const isNotEmpty = (word) => {
  return word?.trim().length > 0
}

const isInputFiledValid = (input) => {
  return input !== undefined  ? input !== 0 ? input.toString().trim().length > 0 :true : false 
}

export { capitalizeAndJoinWithUnderscore, capitalizeAndRemoveUnderscore, capitalizeFirstLetter, isInputFiledValid, isNotEmpty }

export const validateURL = (inputString) => {
  try {
    const url = new URL(inputString)

    if (!['http:', 'https:'].includes(url.protocol)) {
      return false
    }

    return /^.+\.[a-z]{2,}$/i.test(url.hostname)
  } catch {
    return false
  }
}